import { TDevice } from '@cian/utils';

import { IApplicationState, TThunkAction } from '../../types/redux';
import { TFeature } from '../../types/map';
import { toListingUrl } from '../../mappers/queryString';
import { convertBboxToString } from '../../utils/convertBboxToString';
import { removeNewbuildingsFromUrl } from '../../utils/removeNewbuildingsFromUrl';
import { changeSearchResultsUrl, openSearchResultsSidebar } from '../searchResults';
import { markAsViewed } from '../viewed/markAsViewed';
import { selectFeature } from './selectFeature';

export interface IOpenFeatureParams {
  feature: TFeature;
  precision: number;
  isDetailed: boolean;
  deviceType: TDevice;
}

export function openFeature({
  feature,
  precision,
  isDetailed,
  deviceType,
}: IOpenFeatureParams): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const baseUrl = context.config.get<string>('mobileSearchFrontend.browserUrl');
    const currentSubdomain = context.custom.subdomain;
    const featureSubdomain = feature.properties.subdomain;
    const qs = getFeatureQueryString(feature, getState());
    const url = `${baseUrl}v1/get-results-for-map?${qs}&parentOrigin=${window.location.origin}`;
    const urlWithoutNewbuildings = removeNewbuildingsFromUrl(url);

    dispatch(selectFeature(feature, precision));
    dispatch(changeSearchResultsUrl(urlWithoutNewbuildings));
    dispatch(openSearchResultsSidebar());

    if (!feature.properties.isViewed) {
      dispatch(markAsViewed({ feature, precision, isDetailed }));
    }

    if (deviceType !== 'desktop') {
      const url = toListingUrl(qs);
      const urlWithoutNewbuildings = removeNewbuildingsFromUrl(url);

      window.open(
        `//${window.location.hostname.replace(
          `${currentSubdomain}.`,
          `${featureSubdomain}.`,
        )}${urlWithoutNewbuildings}`,
        '_blank',
      );
    }
  };
}

export function getFeatureQueryString(feature: TFeature, state: IApplicationState) {
  const { bbox: featureBBox, isExtended } = feature.properties;
  const { queryString, extendedQueryString } = state;
  const qs = isExtended && extendedQueryString ? extendedQueryString : queryString;

  const bboxString = convertBboxToString(featureBBox);

  return `${qs}&bbox=${bboxString}&isNavigationDisabled=1`;
}
